import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { showNotification, encryptData } from '../../../consts/utils';
import { ApiService } from '../../../shared/services/api.services';
import { SeoService } from '../../../shared/services/seo.service';
import { SharedModule } from '../../../shared/shared.module';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../../consts/super_admin_http_routes';

@Component({
  selector: 'app-reset-password',
  imports: [SharedModule, RouterModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
 form: UntypedFormGroup;
  private userEmail: string;
  private userToken: string;
  show: boolean = false;
  showConfirm: boolean = false;

  constructor(private _formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private seo: SeoService,
    private snackBar: MatSnackBar
  ) {
    /**
        * Sets up SEO meta tags using SeoService
        * This helps in optimizing the page for search engines and social media previews.
    */
    this.seo.setTags({
      title: 'Superadmin reset password Form', // Title
      titleSuffix: '- Shining On Safety', // Title Suffix
      description: 'Shining On Safety', // Description
      image: '', // Image
      keywords: 'Shining On Safety' // Keywords
    });
  }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      this.userEmail = params['email'];
      this.userToken = params['token'];
      if (!this.userToken) {
        showNotification(this.snackBar, 'Token not found', 'error');
        this._router.navigate(['/home']);
      }

      this.form = this._formBuilder.group({
        password: ['',
          [
            Validators.compose([
              Validators.required,
              Validators.maxLength(100)
            ])
          ],
        ],
        confirmPassword: ['',
          [
            Validators.compose([
              Validators.required,
              Validators.maxLength(100)
            ])
          ],
        ]
      });
    });
  }


  resetPassword() {
    if (this.form.invalid) {
      showNotification(this.snackBar, 'Please check the form fields', 'error');
      return;
    }

    const encryptedPassword = encryptData(this.form.get('password')?.value);
    const encryptedConfirmPassword = encryptData(this.form.get('confirmPassword')?.value);
    const encryptedUserEmail = encryptData(this.userEmail);

    var data = {
      password: encryptedPassword,
      confirm_password: encryptedConfirmPassword,
      email: encryptedUserEmail,
      token: this.userToken
    };

    this.apiService.httpPostCallWithoutToken<any>(
      superAdminHttpVersion.V1 + superAdminHttpRoutes.RESET_PASSWORD,
      data
    ).subscribe({
      next: (response: any) => {
        if (response.status) {
          showNotification(this.snackBar, response.message, 'success');
          this._router.navigate(['/superadmin/login']);
        } else {
          showNotification(this.snackBar, response.message, 'error');
        }
      }, error: (error: any) => {
        showNotification(this.snackBar, error.message, 'error');
      }
    });
  }
}
